import type { DmNotification } from '../../../services/dmNotifications';
import { DonePill } from '../shared/DonePill';
import { ReviewNotificationButton } from './ReviewNotificationButton';
import {
    closureText,
    isResolvedNotification,
    notificationClosure
} from './view/resolvedNotificationText';

interface NotificationReviewActionProps {
    notification: DmNotification;
    onReviewed: (notificationId: string) => Promise<void>;
}

export function NotificationReviewAction({
    notification,
    onReviewed
}: NotificationReviewActionProps) {
    if (isResolvedNotification(notification)) {
        return <DonePill detail={closureText(notificationClosure(notification))} />;
    }
    return (
        <ReviewNotificationButton
            notificationId={notification.id}
            eventType={notification.eventType}
            onReviewed={onReviewed}
        />
    );
}
